import { createAsyncThunk } from '@reduxjs/toolkit';
import { createCWTicket } from 'services/connectwise';
import { ICreateCwTicketPayload } from 'services/connectwise/types';

interface IProps {
  psaId: number;
  payload: ICreateCwTicketPayload;
}

export const ThunkCreateCwTicket = createAsyncThunk(
  'connectwise/createCwTicket',
  ({ psaId, payload }: IProps) => createCWTicket(psaId, payload).then(res => res.data),
);
